import PassportUserInputView from "./PassportUserInputView";

export default PassportUserInputView;
